import { ToolbarDesignTokens } from '@primeuix/themes/types/toolbar';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { tFlat } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/toolbar/index.ts
const tb = componentCommon.toolbar;

export const ToolbarTelekomDT: ToolbarDesignTokens = {
  root: tFlat(tb),
};
